export default `p.z-=80.; p=abs(p);
    float s=3., l=0.;
    for(int j=0;j++<8;)
      p=-sign(p)*(abs(abs(abs(p)-2.)-1.)-1.),
      p*=l=-.8/min(2.,length(p)),
      p-=.5, s*=l;
    return (length(p)/s)-0.1;
  }`